import React from "react";
import { withTranslation } from "react-i18next";
import "./InsAutocomplete.scss";

function InsAutocomplete({ values, visible, onClick, t }) {
  return (
    <div className={visible ? "autocomplete show" : "autocomplete"}>
      {values && values.length === 0 && visible && (
        <div className="autocomplete_choice no_result">{t("no_result")}</div>
      )}
      {values && visible
        ? values.map((item, index) => (
            <div
              key={index}
              className="autocomplete_choice"
              onClick={() => {
                onClick(item.name || item);
              }}
            >
              {item.name || item}
            </div>
          ))
        : null}
    </div>
  );
}

export default withTranslation()(InsAutocomplete);
